import { useTheme } from '@mui/material/styles';

const StatusIcon = ({ status, containerProps = {},...props}) => {
  const theme = useTheme();
  //<Box {...containerProps}>
  return (
    <>
      {(status === "Not Started") && theme.icons.START}
      {(status === "In Progress" || status === "All Submitted") && theme.icons.INPROGRESS}
      {(status === "Completed" || status === "Submitted") && theme.icons.COMPLETE}
    </>
  );
}
export default StatusIcon;
